import { render, staticRenderFns } from "./AgenteDetalle.vue?vue&type=template&id=5fb55934&scoped=true"
import script from "./AgenteDetalle.vue?vue&type=script&lang=js"
export * from "./AgenteDetalle.vue?vue&type=script&lang=js"
import style0 from "./AgenteDetalle.vue?vue&type=style&index=0&id=5fb55934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb55934",
  null
  
)

export default component.exports